export default __webpack_public_path__ + "static/media/contact.74cee641.jpeg";